/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const file_xml = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.29 4.5 8.62 1.353A1 1 0 0 0 7.857 1H2a1 1 0 0 0-1 1v11.843a1 1 0 0 0 1 1h2"
    />
    <path
      fill="#000"
      d="m7.733 12.667-1.346-2.4L7.673 8h-1.1l-.7 1.407L5.2 8H4.06l1.28 2.333L4 12.667h1.147l.713-1.427.687 1.427h1.186Zm3.931-4.66h-1.187l-.493 2.273L9.491 8H8.33v4.667h.913V10.24l.347 1.473h.806l.314-1.48v2.44h.953V8.007Zm1.998 3.86V8h-1v4.667h3.066v-.8h-2.066Z"
    />
  </svg>
)
export default file_xml
